import { render } from "./ConfigurationStores.vue?vue&type=template&id=0a8d2978"
import script from "./ConfigurationStores.vue?vue&type=script&lang=js"
export * from "./ConfigurationStores.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__